import type { getHeroVariantStyles as getHeroVariantStylesType } from "../CareSeeker/shared/hero-variants";

import { getHeroVariantStyles } from "../CareSeeker/shared/hero-variants";

type HeroVariantStyles = ReturnType<typeof getHeroVariantStylesType>;

const defaultHeroVariantStyles = getHeroVariantStyles("default");

export type { HeroVariantStyles };

export { defaultHeroVariantStyles };
